import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Snackbar } from '@material-ui/core';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

const styles = () => ({
  errorSnackBarRoot: {
    backgroundColor: '#C60023',
    color: '#fff',
  },
  successSnackBarRoot: {
    backgroundColor: '#4caf50',
    color: '#fff',
  },
  close: {
    cursor: 'pointer',
  },
});

const CustomSnackbar = ({ classes, type = 'error', errorMessage = '', closeCallback }) => {
  const onClose = () => {
    if (typeof closeCallback === 'function') {
      closeCallback();
    }
  };
  return (
    <div className={classes.root}>
      <Snackbar
        open={errorMessage !== ''}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        ContentProps={{
          classes: {
            root: type === 'error' ? classes.errorSnackBarRoot : classes.successSnackBarRoot,
          },
        }}
        message={errorMessage}
        action={
          <div className={classes.close} onClick={onClose}>
            <CloseOutlinedIcon />
          </div>
        }
      />
    </div>
  );
};

CustomSnackbar.propTypes = {
  classes: PropTypes.object,
  closeCallback: PropTypes.func,
  type: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default withStyles(styles)(CustomSnackbar);
